<template>
  <div id="knowledgeBaseStep4Page"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="پایگاه دانش"></ActionBar>
    <FooterMenu :currentPage="'knowledgeBase'"/>
    <div v-if="isLoaded">
    <div v-if="!hasDate" class="row container mx-auto p-0  mt-2">
      <div class="col-12">
        <v-alert
            border="bottom"
            class="mt-4 text-center"
            color="forth"
            dark>
          {{ResultText}}
        </v-alert>
      </div>
    </div>
    <div v-else class="row container mx-auto p-0  mt-2">
      <div class="col-12 mx-auto p-0">
        <div class="card-shadow round10px bg-white p-2 my-2">
          <v-img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" class="round10px"></v-img>
          <div class="grey--text font12px mt-3"><i
              class="fas fa-calendar-alt primary-text ml-3"></i>{{ $convertDate(item.ModifiedDate) }}
          </div>
          <div class="mt-3">{{ item.Name }}</div>
          <div class="mt-3 font12px" v-html="item.Description"></div>
          <div class="col-12 p-1" v-html="item.AparatLink">

          </div>
          <!--          <video class="col-12 p-1 video" controls>-->
          <!--            <source src="" type="video/mp4">-->
          <!--            Your browser does not support HTML video.-->
          <!--          </video>-->
<!--          <v-btn class="mt-3" color="primary" rounded>-->
<!--            <i class="fas fa-download ml-2 pb-1"></i>-->
<!--            دانلود فایل-->
<!--          </v-btn>-->
        </div>
      </div>
    </div>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "KnowledgeBaseStep4",
  metaInfo: {
    title: 'مسیربرتر-پایگاه دانش'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    item: null,
    showLoaderDialog: false,
    isLoaded: false,
    ResultText: '',
    hasDate: false,
  }),
  mounted() {
    _this = this;
    this.showLoaderDialog = true
    this.getData()
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "KnowledgeManagement/SpecialKnowledge?KnowledgeID=" + _this.$route.query.KnowledgeID, requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;

            try {
              _this.item = JSON.parse(result)
              this.hasDate= true
            }catch (e){
           this.ResultText = result
              this.hasDate= false
            }

            _this.isLoaded = true;

          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
  }
}
</script>

<style scoped>

</style>